import { render, staticRenderFns } from "./IdleDetection.vue?vue&type=template&id=b7bcabc8&scoped=true&"
import script from "./IdleDetection.vue?vue&type=script&lang=js&"
export * from "./IdleDetection.vue?vue&type=script&lang=js&"
import style0 from "./IdleDetection.vue?vue&type=style&index=0&id=b7bcabc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bcabc8",
  null
  
)

export default component.exports